import api from '@/api';
import { AxiosResponse } from 'axios';

export default {
    async invoke(): Promise<AxiosResponse> {
        return await api.get('/maintenance');
    },
};
